import { render, staticRenderFns } from "./btn-icon-quarternary.vue?vue&type=template&id=bbf1d7b6&scoped=true"
import script from "./btn-icon-quarternary.vue?vue&type=script&lang=js"
export * from "./btn-icon-quarternary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf1d7b6",
  null
  
)

export default component.exports